module.exports = __webpack_public_path__ + "img/position-accepted-selected.55b597f6.svg";